import { Grid, Typography } from "@mui/material";
import { isString } from "lodash";
import React, { ReactNode } from "react";
interface CuoEmptyProps {
  text: ReactNode;
  icon?: any;
}

export default function CuoEmpty(props: CuoEmptyProps) {
  const { text, icon } = props;
  return (
    <Grid
      container
      height={"100%"}
      alignItems={"center"}
      justifyContent={"center"}
      direction={"column"}
      rowGap={1}
      p={1}
    >
      {icon && (
        <props.icon
          className="size-[30px] text-primary/40"
        />
      )}
      {isString(text) ? <Typography>{text}</Typography> : text}
    </Grid>
  );
}
